<template>
  <div class="content-box" v-if="detail">
    <div class="video wood-bg" v-if="worksType === 'WOOD'"></div>
    <div
      v-else
      class="video"
      @click="openWorks"
      :style="{backgroundImage: `url(${detail.preview_url})`}"
    >
      <div class="play">
        <play-icon class="icon"/>
      </div>
    </div>
    <div class="content-normal">
      <header>
        <h2>{{detail.name}}</h2>
        <p>
          创作时间
          <span>{{detail.created_at | date}}</span>
        </p>
      </header>
      <main v-if="detail.is_mark">
        <div class="person">评分人：{{detail.grader_name}}</div>
        <div class="start">总分：
          <rate
            :value="detail.total_score / 100 * 5"
            disabled
            void-color="#e3feff"
            text-color="#ffe600"
          />
        </div>
        <ul class="skill-list">
          <x-progress title="创新思维" :percentage="detail.creative_score / 25"/>
          <x-progress title="艺术设计" :percentage="detail.artistic_score / 25"/>
          <x-progress title="逻辑分析" :percentage="detail.logical_score / 25"/>
          <x-progress title="编程技术" :percentage="detail.programming_score / 25"/>
        </ul>
        <h5>评语</h5>
        <p class="comment">{{detail.commentary}}</p>
      </main>
      <main class="not-mark" v-else>未评分</main>
    </div>
  </div>
</template>
<script>
import { Rate } from 'element-ui'
import PlayIcon from '@/assets/svg/icon_play.svg'
import { get, post } from '@/utils/ajax'
const worksTypeMap = [
  '',
  'IDE',
  'MC',
  'BOX',
  'ROBOT',
  'BOX2',
  'HARDWARE',
  'WOOD',
  'NEMO'
]
const { box: BOX, player: PLAYER } = CONFIG
export default {
  name: 'WorkDetail',
  created() {
    this.refresh()
    this.$store.dispatch('reportClassroomPageVisitParents')
  },
  data() {
    return {
      detail: null
    }
  },
  computed: {
    worksType() {
      if (!this.detail) return ''
      return worksTypeMap[this.detail.type]
    }
  },
  methods: {
    async refresh() {
      const id = this.$route.query.id
      this.detail = await get(`/edu/wap/works/${id}`)
    },
    async openWorks() {
      const id = this.detail.id
      let url = ''
      switch (this.worksType) {
        case 'IDE':
          url = `${PLAYER}/we/${id}`
          break
        case 'BOX2':
          const { bcmCode } = await post('/edu/wap/code/encode', {
            id,
            type: 3
          })
          url = `${BOX}/w/-1?code=${bcmCode}&pid=PxtCITc9`
          break
      }
      location.href = url
    }
  },
  components: {
    Rate,
    PlayIcon,
    XProgress: {
      functional: true,
      render(
        h,
        {
          props: { title = '', percentage = 0 }
        }
      ) {
        return (
          <li>
            <p>{title}：</p>
            <div class="range">
              <div class="progress" style={{ width: `${percentage * 100}%` }} />
            </div>
          </li>
        )
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.video
  height 281px
  background-color #ccc
  margin-bottom 11px
  flex-shrink 0
  background-cover()
  flex-column-center()
.wood-bg
  background-fit('~@/assets/images/python_bg')
.play
  round(66px)
  flex-column-center()
  border 3px solid $themeColor
  background-color white
  .icon
    width 26px
    height 26px
    transform translate(3px, 0)
header
  // border-1('%23ccc', bottom)
  border-bottom 1px solid #ccc
  margin-bottom 30px
  h2
    font-size 16px
    color #333
    margin-bottom 10px
  p
    margin-bottom 15px
.person
  margin-bottom 10px
  color #333
main
  > h5
    @extend .person
    font-size 14px
  .comment
    margin-bottom 36px
.not-mark
  color #FDC700
.start
  margin-bottom 15px
  color #333
  display flex
  align-items center
  >>> .el-rate
    height initial
  >>> .el-rate__icon
    font-size 12px
    margin-right 1px
.skill-list
  margin-bottom 30px
  li
    margin-bottom 5px
  p
    font-size 13px
    margin-bottom 4px
    color #999
.range, .progress
  height 10px
  border-radius 0 5px 5px 0
.range
  background-color #f6f6f6
  position relative
.progress
  background linear-gradient(135deg, rgba(255, 194, 6, 1), rgba(252, 96, 92, 1))
  position absolute
  top 0
  left 0
</style>
